import React from 'react'

const Program = () => {
  return (
    <div className="program">
        <h2 className="h2mb">잘나가는 개발자가 되어보세요.</h2>
        <div className="program_inner">
            <div className="program_left">
                <div className="program_right_svg">
                    <h3 className="h3mb">내가 접수한 채용 프로그램</h3>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="XFteHAoEX_O2i2sztwAI"><path d="M9 16.34l4.58-4.59L9 7.16l1.41-1.41 6 6-6 6z" fillRule="evenodd"></path></svg>
                </div>
                <div className="program_box">
                    <img alt="빈 아이콘" data-src="https://d1nuzc1w51n1es.cloudfront.net/83825bf25d82d81616f2.png" data-srcset="" className="Yaqh9jI4Nye_YhM3ijp9" src="https://d1nuzc1w51n1es.cloudfront.net/83825bf25d82d81616f2.png" srcSet="" />
                    <p>프로그래머스만의<br /> 특별한 채용 프로그램에 참여해보세요!</p>
                    <span className="btn1">포지션 찾아보기</span>
                </div>
            </div>
            <div className="program_right">
                <div className="program_right_svg">
                    <h3 className="h3mb">진행중인 채용 프로그램</h3>
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="XFteHAoEX_O2i2sztwAI"><path d="M9 16.34l4.58-4.59L9 7.16l1.41-1.41 6 6-6 6z" fillRule="evenodd"></path></svg>
                </div>
                <div className="program_right_inner">
                    <div className="program_box2">
                        <img className="program_box2-img" alt="23년 현대모비스 알고리즘 경진대회" src="https://asset.programmers.co.kr/image/origin/production/competition/166691/f640b8b0-bb0f-4b52-85cd-fe0cd19bf634.png" />
                        <div className="program_box2-1">
                            <h3>23년 현대모비스 알고리즘 경진대회</h3>
                            <div className="program_box2-1-line"></div>
                            <div className="program_box2-1-bottom">
                                <div className="program_box2-1-bottom1-1">
                                    <span>접수일</span>
                                    <p>23-05-26(금) 00:00 ~ 23-06-23(금) 23:59</p>
                                </div>
                                <div className="program_box2-1-bottom1-1">
                                    <span>접수일</span>
                                    <p>23-07-07(금) 14:00 ~ 23-07-07(금) 17:00</p>
                                </div>
                            </div>
                            <span className="btn2 mt30">프로그램 참여하기</span>
                        </div>
                    </div>
                    <div className="program_box2">
                        <img className="program_box2-img" alt="2023 Dev-Matching : 웹 프론트엔드 개발자(상반기)-2" src="https://asset.programmers.co.kr/image/origin/production/competition/166410/4cc841c6-a623-4764-851e-38b65ce6207f.jpeg" />
                        <div className="program_box2-1">
                            <h3>2023 Dev-Matching : 웹 프론트엔드 <br />개발자(상반기)-2</h3>
                            <div className="program_box2-1-line"></div>
                            <div className="program_box2-1-bottom">
                                <div className="program_box2-1-bottom1-1">
                                    <span>접수일</span>
                                    <p>23-05-30(화) 11:00 ~ 23-06-15(목) 17:00</p>
                                </div>
                                <div className="program_box2-1-bottom1-1">
                                    <span>접수일</span>
                                    <p>23-06-17(토) 13:00 ~ 23-06-17(토) 16:00</p>
                                </div>
                            </div>
                            <span className="btn2 mt30">프로그램 참여하기</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Program
